import { fetchWithAuth } from './fetchWithAuth';

export const getReminderDays = async () => {
  const res = await fetchWithAuth('/api/reminders/settings/reminder-days');
  return res.json();
};

export const setReminderDays = async (days) => {
  const res = await fetchWithAuth('/api/reminders/settings/reminder-days', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reminder_days: days }),
  });
  return res.json();
};

export const getPending = async () => {
  const res = await fetchWithAuth('/api/reminders/pending');
  return res.json();
};

export const getLogs = async (limit = 100, offset = 0) => {
  const res = await fetchWithAuth(`/api/reminders/logs?limit=${limit}&offset=${offset}`);
  return res.json();
};

export const addManual = async (data) => {
  const res = await fetchWithAuth('/api/reminders/manual', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const sendNow = async (id) => {
  const res = await fetchWithAuth(`/api/reminders/manual/${id}/send`, { method: 'POST' });
  return res.json();
};
